module.exports = __webpack_public_path__ + "img/tf.tfb52f02c.svg";